import { Component, ViewChild } from "@angular/core";
import { Nav, Platform, AlertController, ToastController } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { Storage } from "@ionic/storage";

import { ConectorProvider } from "../providers/conector/conector";
import { GlobalProvider } from "../providers/global/global";

import { HomePage } from "../pages/home/home";
import { CuadrantePropioPage } from "../pages/cuadrante-propio/cuadrante-propio";
import { PerfilPage } from "../pages/perfil/perfil";
import { LicenciasPage } from "../pages/licencias/licencias";
import { SolicitudesPage } from "../pages/solicitudes/solicitudes";
import { MensajesPage } from "../pages/mensajes/mensajes";
import { CuadranteCentroPage } from "../pages/cuadrante-centro/cuadrante-centro";
import { LoginPage } from "../pages/login/login";
import { LoginIosPage } from "../pages/login-ios/login-ios";
import { FirebaseProvider } from "../providers/firebase/firebase";
import { ComunicacionesPage } from "../pages/comunicaciones/comunicaciones";
import { DocumentosPage } from "../pages/documentos/documentos";
import { HorasPage } from "../pages/horas/horas";
import { OtrosPage } from "../pages/otros/otros";

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = HomePage;

  usuarioname: any;
  versionNum: any;

  pages: Array<{ title: string; component: any }>;

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public global: GlobalProvider,
    private storage: Storage,
    private alertCtrl: AlertController,
    public conector: ConectorProvider,
    private firebaseProvider: FirebaseProvider,
    private toastCtrl: ToastController
  ) {
    this.initializeApp();

    this.notificationSetup();

    // used for an example of ngFor and navigation
    this.pages = [
      { title: "Inicio", component: HomePage },
      { title: "Cuadrante", component: CuadrantePropioPage },
      { title: "Cuadrante centro", component: CuadranteCentroPage },
      { title: "Licencias", component: LicenciasPage },
      { title: "Solicitudes", component: SolicitudesPage },
      { title: "Notificaciones ", component: MensajesPage },
      { title: "Documentos ", component: DocumentosPage },
      { title: "Horas Extr./Compens. ", component: HorasPage },
      { title: "Otros ", component: OtrosPage },
      { title: "Perfil de usuario", component: PerfilPage },
    ];
  }

  ionViewWillEnter() {}

  initializeApp() {
    this.platform.ready().then(async () => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      this.statusBar.styleDefault();
      // let status bar overlay webview
      this.statusBar.overlaysWebView(true);

      // set status bar to white
      this.statusBar.backgroundColorByHexString("#1f4b0b");
      this.conector.getConfiguracion().subscribe((data) => {
        this.global.setConfigura(data);
      });

      //this.conector.getVersion();

      this.storage.get("DataUser").then((val) => {
        // guardamos en el global los datos de user que estan en el storage
        if (val) {
          this.global.setDataUser(val);
          this.storage.get("UKT").then((val) => {
            // guardamos en el global los datos de ukt que estan en el storage
            this.global.setukt(val);
          });

          this.usuarioname = this.global.DATAUSER["usuario"];
        }

        this.storage.get("Logged").then((val) => {
          if (val) {
            this.global.setlogged(true);
            this.nav.setRoot(HomePage);
            let TextLOG = " LOGIN en la aplicacion ";
            this.conector.registraractividad(TextLOG).subscribe((data) => {
              console.log("registramos Actividad", TextLOG);
            });
          } else {
            if (this.platform.is("ios")) {
              this.nav.setRoot(LoginIosPage);
            } else {
              this.nav.setRoot(LoginPage);
            }
          }
        });
      }); // datauser
    }); //ready

    this.platform.registerBackButtonAction(() => {
      if (this.nav.canGoBack()) {
        this.nav.pop();
      } else {
        const alert = this.alertCtrl.create({
          title: "Salir de la app",
          message: "Confirma que quieres cerrar esta app",
          buttons: [
            {
              text: "Cancelar",
              role: "cancel",
              handler: () => {
                // this.nav.setRoot(HomePage);
                console.log("** Cancelamos salida **");
              },
            },
            {
              text: "Cerrar la app",
              handler: () => {
                this.logout();
                this.platform.exitApp();
              },
            },
          ],
        });
        alert.present();
      }
    }); // registerBAckbuuton

    this.splashScreen.hide();
  } // initializeapp

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  goToLogin() {
    if (this.platform.is("ios")) {
      this.nav.setRoot(LoginIosPage);
    } else {
      this.nav.setRoot(LoginPage);
    }
  }

  logout() {
    let alert = this.alertCtrl.create({
      title: "Logout",
      message: "¿Seguro que quieres desconectar?",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
          handler: () => {
            console.log("Cancelar");
          },
        },
        {
          text: "Sí",
          handler: () => {
            console.log("hacer logout");

            let TextLOG = " LOGOUT de la aplicacion ";

            this.global.setlogged(false);
            this.global.setDataUser({});
            this.global.setukt({});

            if (this.platform.is("ios")) {
              this.nav.setRoot(LoginIosPage);
            } else {
              this.nav.setRoot(LoginPage);
            }
            this.conector.registraractividad(TextLOG).subscribe((data) => {
              console.log("registramos Actividad", TextLOG);
            });
          },
        },
      ],
    });
    alert.present();
  }

  private async presentToast(message) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
    });
    toast.present();
  }

  private notificationSetup() {
    console.log("notificacion");
    this.firebaseProvider.onNotificationOpen().subscribe((msg) => {
      console.log("notificacion: ", msg);
      if (this.platform.is("ios")) {
        this.presentToast(msg.aps.alert);
      } else {
        this.presentToast(msg.body);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts